import React, { useEffect, useState } from 'react';

// Live countdown for a rate-limited row. It only tells the pricer when a retry
// is worth it — price writes are NEVER re-sent automatically.
function RetryCountdown({ until }) {
  const secsLeft = () => Math.max(0, Math.ceil((until - Date.now()) / 1000));
  const [left, setLeft] = useState(secsLeft);
  useEffect(() => {
    setLeft(Math.max(0, Math.ceil((until - Date.now()) / 1000)));
    const t = setInterval(() => setLeft(Math.max(0, Math.ceil((until - Date.now()) / 1000))), 1000);
    return () => clearInterval(t);
  }, [until]);
  return <span>{left > 0 ? `retry in ${left}s` : 'you can retry now'}</span>;
}

export default RetryCountdown;
